import React from 'react';
import { Table } from 'src/components/matchbox';
import HeaderLabel from './HeaderLabel';

function Head({ columns, onSort, order }) {
  return (
    <thead>
      <Table.Row header>
        {columns.map(({ align = 'left', dataKey, label, sortable, width }) => (
          <Table.HeaderCell align={align} key={`header-${dataKey}`} width={width}>
            <HeaderLabel
              dataKey={dataKey}
              label={label}
              onSort={onSort}
              order={order}
              sortable={sortable}
            />
          </Table.HeaderCell>
        ))}
      </Table.Row>
    </thead>
  );
}

export default Head;
